export const CHAT_BOT_ASESOR_V2_TOOLTIP = `
    Chat Advisor ha sido diseñado como un apoyo a colaboradores de la compañía, albergando información de diversas áreas, tales como:
    Legal, Operaciones Mesa, Tributario/Previsional, Asesoría/Inversiones, Productos, Web y Clientes/Carterización.
`;
